import { Tabs } from "antd";
import type { TabsProps } from "antd";
import React from "react";

export type AppTabsProps = TabsProps;

const AppTabs = React.forwardRef<HTMLDivElement, AppTabsProps>(
  (props, ref) => {
    const { type = "line", ...rest } = props;

    return (
      <div ref={ref}>
        <Tabs type={type} {...rest} />
      </div>
    );
  },
);

AppTabs.displayName = "AppTabs";

export default AppTabs;
